import axios from "axios";
// Login with Api
export let signIn = async (userName, userPassword) => {

  try {
    const url = process.env.REACT_APP_ADMIN_API_URL + "/login";
    let data = "";
    let qs = require('qs');

    data = qs.stringify({
      'email': userName,
      'password': userPassword
    });

    const response = await axios.post(
      url,
      data
    );
    return response.data
  } catch (error) {
    throw error;
  }
};

// Logout with Api
export let logOut = async (token) => {

  try {
    const url = process.env.REACT_APP_ADMIN_API_URL + "/logout";

    await axios.post(
      url,
    {
      headers: {
          'Authorization': 'Bearer '+token, 
          'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  return true;
  } catch (error) {
    throw error;
  }
};